export default __webpack_public_path__ + "static/scientist-female-c8f6ef626094e569bda442f8628e4d5f.png";